// Central pronoun / terminology helper for UI copy (mirrors backend services/pronouns.py).
const SETS = {
  "she/her": { subject: "she", object: "her", possessive: "her", plural: false, label: "she/her" },
  "he/him": { subject: "he", object: "him", possessive: "his", plural: false, label: "he/him" },
  "they/them": { subject: "they", object: "them", possessive: "their", plural: true, label: "they/them" },
};

export function pronounSet(partnerPronouns, alias, customPronouns) {
  const key = (partnerPronouns || "").toLowerCase();
  let base = SETS[key];
  if (!base && key === "other" && customPronouns) {
    const parts = customPronouns.toLowerCase().split(/[\/,\s]+/).filter(Boolean);
    if (parts.length && /^[a-z'’-]{1,12}$/.test(parts[0])) {
      const std = { he: "he/him", she: "she/her", they: "they/them" }[parts[0]];
      base = std ? SETS[std] : { subject: parts[0], object: parts[1] || parts[0], possessive: parts[2] || parts[1] || parts[0], plural: false, label: parts.slice(0, 3).join("/") };
    }
  }
  base = base || { ...SETS["they/them"], label: key === "other" ? "other" : "not specified" };
  const person = (alias || "").trim() || "this person";
  return {
    ...base,
    key: SETS[key] ? key : (key === "other" ? "other" : "unknown"),
    person,
    verb: (sing, plur) => (base.plural ? plur : sing),
    cap: (s) => s.charAt(0).toUpperCase() + s.slice(1),
  };
}

export const NEUTRAL = pronounSet(null);
